import { css } from '@eti/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const rowWrapperStyles = css`
  display: flex;

  html[dir='rtl'] & {
    flex-direction: row-reverse;
  }

  & > * {
    margin: 0.3125rem 0;

    &:not(:last-child) {
      margin-right: 0.25rem;
    }
  }
`;
const RowWrapper = props => /*#__PURE__*/_jsx("div", {
  className: rowWrapperStyles,
  ...props
});
export default RowWrapper;
//# sourceMappingURL=RowWrapper.js.map